import SelectableTile from '@carvana/ds-selectable-tile';
import type { BodyStyle } from '@carvana/merch-search-bar';
import { assetsCdnUrl } from '~/constants/environment';
import toLowerKebabCase from '~/utilities/toLowerKebabCase';
import VehicleCarousel from '../VehicleCarousel';

type OwnProps = {
  items: Array<BodyStyle>;
  onSelect: (bodyStyle: BodyStyle) => void;
};

export default function PopularVehicleStyles({ items, onSelect }: OwnProps) {
  return (
    <VehicleCarousel
      hasGutterPadding={false}
      headerTitle="Popular vehicle styles"
    >
      {items.map(bodyStyle => (
        <div className="w-[140px] shrink-0" key={bodyStyle.text}>
          <SelectableTile
            variant="simple-select"
            value={bodyStyle.text}
            onClick={() => onSelect(bodyStyle)}
            headline={bodyStyle.text}
            testId="popular-vehicle-style-tile"
            data-testid="popular-vehicle-style-tile"
            data-analytics-id={toLowerKebabCase(
              'popular vehicle styles',
              bodyStyle.text
            )}
            data-analytics-attributes={JSON.stringify({
              filters: bodyStyle.filters
            })}
          >
            <img
              alt=""
              className="mx-auto max-w-full"
              src={`${assetsCdnUrl}${bodyStyle.image}`}
            />
          </SelectableTile>
        </div>
      ))}
    </VehicleCarousel>
  );
}
